import { Navigate } from 'react-router-dom';
import type { PropsWithChildren } from 'react';
import type { PermissionKey } from '@kalachand/shared';
import { useAuth } from '../../lib/auth';

/**
 * Route-level permission gate. A user without the required permission(s) is
 * bounced to "/" — AutoLanding then sends them to whichever dashboard fits
 * their role. Pair this with <RequireAuth> at the shell level.
 */
export function RequirePermission({
  permission,
  permissions,
  any,
  children,
}: PropsWithChildren<{
  permission?: PermissionKey;
  permissions?: PermissionKey[];
  any?: boolean;
}>): JSX.Element {
  const { perms, loading } = useAuth();
  if (loading) return <></>;
  const keys: PermissionKey[] = permission ? [permission] : (permissions ?? []);
  const ok = any ? keys.some((k) => perms.has(k)) : keys.every((k) => perms.has(k));
  if (!ok) return <Navigate to="/" replace />;
  return <>{children}</>;
}
